exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-saldo {\n  margin-top: 10px;\n  padding: 12px;\n  border: 1px solid #e95814;\n  border-radius: 8px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n.info-saldo .icon-war {\n  margin-right: 10px;\n}\n.info-saldo .text {\n  color: #ff720a;\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.02em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/components/avaible-balance-info/avaible-balance-info.component.styl
// module id = ../../../../../src/app/shared/components/avaible-balance-info/avaible-balance-info.component.styl
// module chunks = main